var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
import { ComponentDataSchema } from "./components/types.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let SwapComponentsSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "swapComponents", []);
    __publicField(this, "swapData", []);
    __publicField(this, "swapped");
  }
};
__decorateClass([
  type(["string"])
], SwapComponentsSchema.prototype, "swapComponents", 2);
__decorateClass([
  type([ComponentDataSchema])
], SwapComponentsSchema.prototype, "swapData", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], SwapComponentsSchema.prototype, "swapped", 2);
SwapComponentsSchema = __decorateClass([
  Component("SwapComponents")
], SwapComponentsSchema);
const __vite_glob_0_17 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SwapComponentsSchema() {
    return SwapComponentsSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  SwapComponentsSchema as S,
  __vite_glob_0_17 as _
};
//# sourceMappingURL=SwapComponents-882395c8.js.map
